module.exports = __webpack_public_path__ + "img/synicyn.cab38e93.jpg";